import EventNotAvailableForPublic from './EventNotAvailableForPublic';

export default EventNotAvailableForPublic;
